import React from "react";
import ReactDOM from "react-dom";
// import { Trans } from 'gatsby-plugin-react-i18next';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup} from 'pure-react-carousel'
import Trans from '../../components/Trans'

const TestimonialsBrandsEn = () => { 
    return (
        <div>
            <section className="testimonial-slider container text-center px-6 py-40">
            <h2 className="mb-10 md:mb-20 section-title">
                <Trans>Testimonial from our Brand Partners</Trans>
            </h2>
            <CarouselProvider className="max-w-4xl relative mx-auto"
                naturalSlideWidth={100}
                naturalSlideHeight={60}
                totalSlides={3}
            >
            <div className="quote-icon1 relative">
                <img loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/w_150/gatsbycms/uploads/2021/05/quotation-mark.svg" alt="quote-icon" />
            </div>
            <Slider className="rounded-lg bg-purple-50">
                    <Slide index={0}>
                        <div className="mx-auto p-6 md:p-20">
                            <div className="client-img mb-10">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/vantagecms/uploads/2020/07/akshay-mehrotra.png" alt="Akshay Mehrotra"/>
                            </div>
                            <p className="mb-10 section-subtitle">
                                <Trans>At EarlySalary, we are looking to help young salaried professionals every time they fall short of cash. Our partnership with Vantage Circle has been instrumental in helping us reach 1 lakh loans and is one of the top partners for EarlySalary. Vantage Circle has helped us reach out and engage with a large corporate audience.</Trans>
                            </p>
                            <div className="client-description">
                                <div className="font-bold text-lg">Akshay Mehrotra</div>
                                <div className="mb-5">Co-Founder & CEO, <b>EarlySalary.com</b></div>
                            </div>
                            <div className="testimonial-company-logo">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/vantagecms/uploads/2020/07/ad_earlysalary.png" alt="Early Salary"/>
                            </div>
                        </div>
                    </Slide>
                    <Slide index={1}>
                        <div className="mx-auto p-6 md:p-20">
                            <div className="client-img mb-10">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/uploads/2019/11/default-people.png" alt="Profile"/>
                            </div>
                            <p className="mb-10 section-subtitle">
                                <Trans>Vantage Circle helped us choose and customize offers which helped us grow our business by targeting a trusted network of corporate employees.</Trans>
                            </p>
                            <div className="client-description">
                                <div className="font-bold text-lg">Rohit Malhotra</div>
                                <div className="mb-5">Regional Head, <b>Samsung Mobiles</b></div>
                            </div>
                            <div className="testimonial-company-logo">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/vantagecms/uploads/2020/07/ad_samsung.png" alt="Samsung"/>
                            </div>
                        </div>
                    </Slide>
                    <Slide index={2}>
                        <div className="mx-auto p-6 md:p-20">
                            <div className="client-img mb-10">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/uploads/2019/11/default-people.png" alt="Profile"/>
                            </div>
                            <p className="mb-10 section-subtitle">
                                <Trans>Vantage Circle allowed us to reach out to our ideal audience and build brand awareness and generate consistent sales every month.</Trans>
                            </p>
                            <div className="client-description">
                                <div className="font-bold text-lg">Amruta Gupta</div>
                                <div className="mb-5">National Brand Head, <b>Pepperfry</b></div>
                            </div>
                            <div className="testimonial-company-logo">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/vantagecms/uploads/2020/07/ad_pepperfry.png" alt="Samsung"/>
                            </div>
                        </div>
                    </Slide>
                    {/* <Slide index={2}>
                        <div className="mx-auto p-6 md:p-20">
                            <div className="client-img mb-10">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/uploads/2019/11/default-people.png" alt="Profile"/>
                            </div>
                            <p className="mb-10 section-subtitle">
                                <Trans>Vantage Circle allowed us to reach out to our ideal audience and build brand awareness and generate consistent sales every month.</Trans>
                            </p>
                            <div className="client-description">
                                <div className="font-bold text-lg">Amruta Gupta</div>
                                <div className="mb-5"><Trans></Trans>National Brand Head, <b>Pepperfry</b></div>
                            </div>
                            <div className="testimonial-company-logo">
                                <img className="mx-auto" src="https://res.cloudinary.com/vantagecircle/image/upload/vantagecms/uploads/2020/07/ad_pepperfry.png" alt="Pepperfry"/>
                            </div>
                        </div>
                    </Slide> */}
                </Slider>
                <ButtonBack className="shadow eb-carousel-btn">
                    <svg className="mx-auto text-purple-200" fill="currentColor" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg>
                </ButtonBack>
                <ButtonNext className="shadow eb-carousel-btn">
                    <svg className="mx-auto text-purple-200" fill="currentColor" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg>
                </ButtonNext>
                <DotGroup />
                </CarouselProvider>
            </section>
        </div>
    )
}


const renderTestimonials=()=>{
    if(typeof window !== "undefined"){ 
        let id = document.querySelector("#testimonials-brands-en")
        if (id != null){
            ReactDOM.render(
                <TestimonialsBrandsEn />,
                id
            )
        }
    }
}

setTimeout(renderTestimonials,100)

export default TestimonialsBrandsEn;

